import { locationAppartementDetail, locationAppartementList } from './properties.ts/locationAppartement'
import { venteBienAgricoleDetail } from './properties.ts/venteBienAgricole'
import { venteMaisonDetail, venteMaisonList } from './properties.ts/venteMaison'

export const allProperties = [locationAppartementList, venteMaisonList]

export const allPropertiesDetail = [locationAppartementDetail, venteMaisonDetail, venteBienAgricoleDetail]
